// extracted by mini-css-extract-plugin
export default {"fields":"ItemFormModal_fields__KRfQ8"};